/**
 * Clés React Query — module Qualité (20_QUAL).
 *
 * Le registre NC et le plan d'actions passent par `<DataTable mode="server">`,
 * dont la clé de cache est `[endpoint, params]` (gérée par useDataTableServer).
 * Ces clés-ci couvrent les requêtes hors DataTable : fiche, commentaires,
 * actions liées, référentiels et leur usage.
 */

const nonConformitiesAll = ['non-conformities'] as const
const qualityActionsAll = ['quality-actions'] as const
const qualityReferentialsAll = ['quality-referentials'] as const

export const qualityKeys = {
    nonConformities: {
        all: nonConformitiesAll,
        detail: (id: string) => [...nonConformitiesAll, 'detail', id] as const,
        comments: (id: string) => [...nonConformitiesAll, 'comments', id] as const,
        actions: (id: string) => [...nonConformitiesAll, 'actions', id] as const,
        // Vue KANBAN : une requête keyset PAR COLONNE (moule SALE-009) + une
        // requête de facettes pour les agrégats d'en-tête. Sous le préfixe
        // `non-conformities` → les invalidations existantes les couvrent déjà.
        board: {
            all: [...nonConformitiesAll, 'board'] as const,
            columns: (scope: string) => [...nonConformitiesAll, 'board', 'column', scope] as const,
            column: (scope: string, status: string) =>
                [...nonConformitiesAll, 'board', 'column', scope, status] as const,
            facets: (scope: string) => [...nonConformitiesAll, 'board', 'facets', scope] as const,
        },
    },
    qualityActions: {
        all: qualityActionsAll,
        detail: (id: string) => [...qualityActionsAll, 'detail', id] as const,
        board: {
            all: [...qualityActionsAll, 'board'] as const,
            columns: (scope: string) => [...qualityActionsAll, 'board', 'column', scope] as const,
            column: (scope: string, status: string) =>
                [...qualityActionsAll, 'board', 'column', scope, status] as const,
            facets: (scope: string) => [...qualityActionsAll, 'board', 'facets', scope] as const,
        },
    },
    qualityReferentials: {
        all: qualityReferentialsAll,
        // ⚠️ `usage` fait PARTIE de la clé. Les deux usages n'ont pas le même
        // périmètre — saisir une valeur sur une fiche se fait dans self ∪ ancêtres,
        // filtrer un registre consolidé dans self ∪ ancêtres ∪ rattachées. Sans cette
        // dimension, les deux listes partagent la même entrée de cache pendant
        // 5 minutes : le sélecteur de la fiche pouvait alors être servi avec les
        // valeurs d'une agence sœur, que le serveur refuserait ensuite d'écrire.
        list: (entityId: string, refType: string, usage: 'entry' | 'filter' = 'entry') =>
            [...qualityReferentialsAll, 'list', entityId, refType, usage] as const,
        usage: (id: string) => [...qualityReferentialsAll, 'usage', id] as const,
    },
}
